const PREFIX = "Shared/DealSetup/";

export const RECEIVE_DEAL_SETUP = `${PREFIX}RECEIVE_DEAL_SETUP`;
